export function backdate(moment: Date, amount: number, period: Period) {
    const [get, set] = operations.get(period);
    const updatedValue = get.apply(moment) - amount;
    set.apply(moment, [updatedValue])
    return moment;
}

export function postdate(moment: Date, amount: number, period: Period) {
    const [get, set] = operations.get(period);
    const updatedValue = get.apply(moment) + amount;
    set.apply(moment, [updatedValue])
    return moment;
}
export enum Period {
    Year,
    Month,
    Day,
}

const operations = new Map<Period, [Function, Function]>([
    [Period.Day, [Date.prototype.getDate, Date.prototype.setDate]],
    [Period.Month, [Date.prototype.getMonth, Date.prototype.setMonth]],
    [Period.Year, [Date.prototype.getFullYear, Date.prototype.setFullYear]]
])

